// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { isUserLoggedIn } from '@utils'
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
import themeConfig from '../../configs/themeConfig'
import Cookies from 'universal-cookie'

const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 7
let getUserCall = false
const myEncodeURIComponent = DefaultConfig().myEncodeURIComponent
const myDecodeURIComponent = DefaultConfig().myDecodeURIComponent
const requestBlockMessage = DefaultConfig().requestBlockMessage

// const getToken = () => {
//   const expiryTimestamp = localStorage.getItem('tokenExpiry')
//   if (!expiryTimestamp) {
//     return false
//   }
//   const now = new Date().getTime()
//   if (now > parseInt(expiryTimestamp, 10)) {
//     return false
//   }

//   return true
// }

// let callUiConfiguration = false
let count = 0

const getUserApiCall = () => {
  axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
    .then((res) => {
      const result = res.data
      // callUiConfiguration = false
      if (result) {
        const data = result.data
        if (data) {
          const azureAdB2C = data.azureAdB2C
          const merchantOne = data.merchantOne
          const JsScriptData = data.jsScriptData
          azureAdB2C['apiUrl'] = GlobalVariable.hostpath
          azureAdB2C['hostname'] = window.location.origin
          localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
          localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
          localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
          const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
          localStorage.setItem('expiryTime', expiryTimestamp)
          const localStorageToken = localStorage.getItem('token')
          axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
            headers: { Authorization: `Bearer ${localStorageToken}` }
          }).then((res) => {
            const userData = res.data
            if (userData.success) {
              if (userData.data) {
                if (userData.data.isResetPassword === true) {
                  toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 3000)
                } else {
                  const cookies = new Cookies()
                  cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                  localStorage.setItem('userData', JSON.stringify(userData.data))
                }
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              localStorage.clear()
              window.location.reload()
            }
          }).catch((error) => {
            const errorresponse = error.response
            const azureAdB2C = localStorage.getItem('azureAdB2C')
            if (errorresponse) {
              const status = errorresponse.status
              if (status === 403 || status === 401) {
                localStorage.clear()
                window.location.reload()
              } else if (status === 406) {
                window.location.reload()
              } else if (status === 412) {
                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                localStorage.clear()
                window.location.href = AzureB2CLogoutUrl
              } else if (status === 417 || status === 424) {
                if (count !== 2) {
                  count = count + 1
                }
                if ((count + 1) === 3) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                setTimeout(() => {
                  localStorage.clear()
                  window.location.reload()
                }, 2000)
              }
            }
          })
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 404) {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
      }
    })
}

const apiCall = async (method, endpoint, data, value) => {
  const authAxios = DefaultConfig().authAxios
  // const token = getToken()
  // if (!token && !callUiConfiguration) {
  //   callUiConfiguration = true
  //   getUserApiCall()
  // }
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (!value) {
              if (respData.errorMessage) {
                toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              }
              return ''
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'put') {
    return await authAxios.put(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

const apiUpdateCall = async (method, endpoint, data, toasttype) => {
  // console.log(method, endpoint, data)
  const authAxios = DefaultConfig().authAxios
  if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            if (toasttype === 'filesave') {
              toast(t => (<ToastMessage t={t} message={"File Saved Successfully"} status={"success"} />))
            } else if (toasttype === 'fileremove') {
              toast(t => (<ToastMessage t={t} message={"File Removed Successfully"} status={"success"} />))
            } else if (toasttype === 'updaTed') {
              toast(t => (<ToastMessage t={t} message={"Updated Successfully"} status={"success"} />))
            } else if (toasttype === 'saveImage') {
              toast(t => (<ToastMessage t={t} message={"Image Saved Successfully"} status={"success"} />))
            } else if (toasttype === 'comment' && data.name !== 'ERBNDA') {
              toast(t => (<ToastMessage t={t} message={"Comment Saved Successfully"} status={"success"} />))
            } else if (toasttype === 'Yes/No') {
              //
            } else {
              toast(t => (<ToastMessage t={t} message={"Work Order Updated Successfully"} status={"success"} />))
            }
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
  const method = 'get'
  const endpoint = `User/GetRefreshToken`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    localStorage.setItem("token", resultData.id_token)
    localStorage.setItem("refresh_token", resultData.refresh_token)
    getUserApiCall()
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Categories
export const getWorkOrderTypesAndCategories = createAsyncThunk("appCommonReducers/getWorkOrderTypesAndCategories", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetWorkOrderTypesAndCategories
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Stages
export const getWorkorderStages = createAsyncThunk("appCommonReducers/getWorkorderStages", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetWorkorderStages
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Country and States
export const getCountryStates = createAsyncThunk("appCommonReducers/getCountryStates", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetCountryStates
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const countrys = []
    resultData.forEach((element) => {
      countrys.push({ value: element.countryCode, label: element.countryName, states: element.statesList })
    })
    return {
      data: countrys,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Company Details
export const getCompanyDetails = createAsyncThunk("appCommonReducers/getCompanyDetails", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetCompanyDetails
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const company = []
    resultData.forEach((element) => {
      company.push({ value: element.companyId, label: element.name })
    })
    return {
      data: company,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get CM Company Details
export const getCMCompanyDetails = createAsyncThunk("appCommonReducers/getCMCompanyDetails", async () => {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const companyIds = userData?.companies?.map(item => item.companyId)
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserCompanies}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const company = []
    resultData.forEach((element) => {
      if (companyIds.includes(element.companyId)) {
        company.push({
          value: element.companyId, label: element.companyName, name: element.companyName, agentId: element.agentId, isActive: element.isActive, sfUniqueId: element.sfUniqueId ? element.sfUniqueId : null
        })
      }
    })
    const trueBool = true
    return {
      data: company,
      spinner: true,
      tokenExp: false,
      unauthorize: company.length === 0 ? false : trueBool
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false,
      unauthorize: false
    }
  }
})

// Get Primary Company Details
export const getPrimaryCompanyDetails = createAsyncThunk("appCommonReducers/getPrimaryCompanyDetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetParentCompany}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const primaryCompany = []
    const primaryBillingAddress = []
    resultData.forEach((element) => {
      primaryCompany.push({ value: element.companyId, label: element.name, agentId: element.agentId })
      primaryBillingAddress.push({ value: element.companyId, label: element.name, billingAddress: element.billingAddress, agentId: element.agentId })
    })
    return {
      data: primaryCompany,
      primaryData: primaryBillingAddress,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Customer Dashboard Workorders
export const getWorkorders = createAsyncThunk("appCommonReducers/getWorkorders", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetCustomerWorkorders
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
    const recCount = resultData.count
    const gridSize = resultData.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Employee Dashboard WOrkorders based on pagination
export const getWorkordersByFilters = createAsyncThunk("appCommonReducers/getWorkordersByFilters", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterWorkorders
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.workorder_DTO ? resultData.workorder_DTO : []
    const recCount = resultData.count
    const gridSize = resultData.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Employee Dashboard WOrkorders based on pagination
export const getVesselDashboard = createAsyncThunk("appCommonReducers/getVesselDashboard", async (woData) => {
  const method = 'post'
  const endpoint = `${woData.categoryId}/${woData.type}/${ApiUrls.GetVesselDashboard}`
  const data = woData.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.vesselDashboardData ? resultData.vesselDashboardData : []
    const recCount = resultData.count
    const gridSize = resultData.pageSize ? resultData.pageSize : 10
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getVesselDashboardByIMO = createAsyncThunk("appCommonReducers/getVesselDashboardByIMO", async (woData) => {
  const method = 'post'
  const endpoint = `${woData.categoryId}/${woData.type}/${ApiUrls.GetVesselDashboard}`
  const data = woData.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData ? resultData : []
    return {
      data: workordersDto,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateSubscription = createAsyncThunk("appCommonReducers/UpdateSubscription", async (woData) => {
  const method = 'post'
  const endpoint = `${woData.categoryId}/${woData.type}/${ApiUrls.UpdateSubscription}`
  const data = woData.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      cancelSub: woData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Employee Dashboard WOrkorders based on pagination
export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: `${element.firstName} ${element.lastName}`, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Create Workorder Validation Checking for exist or not
export const ValidateWorkorderCreation = createAsyncThunk("appCommonReducers/ValidateWorkorderCreation", async (obj) => {
  const method = 'get'
  const endpoint = `${obj.categoryId}/${obj.type}/${ApiUrls.ValidateWorkorderCreation}?companyId=${obj.companyId ? obj.companyId : 0}`
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Validate Client Checking for exist or not
export const GetValidateClient = createAsyncThunk("appCommonReducers/GetValidateClient", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateClient}?uniqueNumber=${wdata.value}&isParentWorkorder=${wdata.check}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Validate Waypoint Agent Checking for exist or not
export const GetValidateWaypointAgent = createAsyncThunk("appCommonReducers/GetValidateWaypointAgent", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateWaypointAgent}?agentId=${wdata.value}&isPlaceholder=${wdata.isPlaceHolderAccount}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Company Details in salesforce
export const GetCompanyDetailsByName = createAsyncThunk("appCommonReducers/GetCompanyDetailsByName", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetSFCompaniesByName}/${name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

// Create Company
export const CreateCompany = createAsyncThunk("appCommonReducers/CreateCompany", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.CreateCompany
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

// Get Base Workorder Data
export const getBaseWorkorderData = createAsyncThunk("appCommonReducers/getBaseWorkorderData", async (wdata) => {
  if (wdata.value === 'ena') {
    const method = 'get'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetBaseWorkOrderData}`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    } else {
      return {
        data: null,
        spinner: true,
        tokenExp: false
      }
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Get Template Workorder Data
export const getDocumentTemplateData = createAsyncThunk("appCommonReducers/getDocumentTemplateData", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDocumentTemplateData}?documentId=${wdata.documentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false,
      reqData: wdata
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false,
      reqData: wdata
    }
  }
})

// Get GetVesselSyncData Data
export const GetVesselSyncData = createAsyncThunk("appCommonReducers/GetVesselSyncData", async (wdata) => {
  const method = 'get'

  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselSyncData}?officialNumber=${Number(wdata?.officialNumber)}&companyId=${wdata?.companyId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data, wdata.errorChecking)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false,
      reqData: wdata
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false,
      reqData: wdata
    }
  }
})

// Create workorder
export const CreateWorkorder = createAsyncThunk("appCommonReducers/CreateWorkorder", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.CreateWorkorder}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Workorder Data
export const getWorkordersData = createAsyncThunk("appCommonReducers/getWorkordersData", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetWorkorderById}?id=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

// Update Workorder Json Data
export const updateWoData = createAsyncThunk("appCommonReducers/updateWoData", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorderData}?woId=${wdata.woData.id}`
  const data = wdata.woData
  const type = wdata.type
  const resultData = await apiUpdateCall(method, endpoint, data, type)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const updateWoExpenses = createAsyncThunk("appCommonReducers/updateWoExpenses", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateExpenses}?woId=${wdata.woData.id}`
  const data = wdata.woData
  const type = wdata.type
  const resultData = await apiUpdateCall(method, endpoint, data, type)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateNdaDocument = createAsyncThunk("appCommonReducers/UpdateNdaDocument", async (wdata) => {
  const method = 'patch'
  // const endpoint = `${ApiUrls.UpdateNdaDocument}?woId=${values.woId}&fileId=${values.fileId}`
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNdaDocument}?woId=${wdata.woId}&fileId=${wdata.fileId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// SendAcknowledgementMail Get Workorder Data
export const signAcknowledgement = createAsyncThunk("appCommonReducers/signAcknowledgement", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.SendAcknowledgementMail}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update Workorder Data
export const UpdateWorkorder = createAsyncThunk("appCommonReducers/UpdateWorkorder", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateWorkorder}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update RequestMoreInfo Data
export const UpdateIsNeedMoreInfo = createAsyncThunk("appCommonReducers/UpdateIsNeedMoreInfo", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RequestMoreInfo}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update UpdateNeedMoreInfoStatus Data
export const UpdateNeedMoreInfoStatus = createAsyncThunk("appCommonReducers/UpdateNeedMoreInfoStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateNeedMoreInfoStatus}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Cancel Workorder
export const CancelWorkorder = createAsyncThunk("appCommonReducers/CancelWorkorder", async (wdata) => {
  const method = 'put'
  let dynamicUrl = ''
  if (wdata.modalName === 'Cancel') {
    dynamicUrl = ApiUrls.CancelWorkorder
  } else if (wdata.modalName === 'Archive') {
    dynamicUrl = ApiUrls.ArchivedWorkorder
  } else if (wdata.modalName === 'Suspend') {
    dynamicUrl = ApiUrls.SuspendWorkorder
  } else if (wdata.modalName === 'Reactivate') {
    dynamicUrl = ApiUrls.ReactivateWorkorder
  }
  let endpoint = `${wdata.ccode}/${wdata.tcode}/${dynamicUrl}?companyId=${wdata.comId}&woId=${wdata.woId}`
  if (wdata.modalName === 'Archive') {
    endpoint += `&cancelInvoice=${wdata.cancelInvoice}`
  }
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Resend Docusign Email
export const ResendDocusignEmail = createAsyncThunk("appCommonReducers/ResendDocusignEmail", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendDocusignEmail}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Acknowledgement Docusign Email
export const SendAcknowledgementMail = createAsyncThunk("appCommonReducers/SendAcknowledgementMail", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.SendAcknowledgementMail}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})
// Get Invoice Document
export const GetInvoiceDocument = createAsyncThunk("appCommonReducers/GetInvoiceDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInvoiceDocument}?invoiceId=${wdata.invoiceId}&woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get download file
export const DownloadFile = createAsyncThunk("appCommonReducers/DownloadFile", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.DownloadFile}?fileId=${wdata.fileId}&imoNumber=${wdata.imoNumber}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const DownloadIMOFile = createAsyncThunk("appCommonReducers/DownloadIMOFile", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.DownloadFile}`
  const data = { filePath: wdata.filePath, imoNumber: wdata.imoNumber }
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFileUrl = createAsyncThunk("appCommonReducers/GetFileUrl", async (wdata) => {
  const method = 'get'
  const endpoint = `PUB/RLM/${ApiUrls.GetFileUrl}?filePath=${wdata.path}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Last Modified files
export const GetLastModifiedFiles = createAsyncThunk("appCommonReducers/GetLastModifiedFiles", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetLastModifiedFiles}?count=10`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Search Library
export const GetSearchLibrary = createAsyncThunk("appCommonReducers/GetSearchLibrary", async (wdata) => {
  const method = 'get'
  const searchKey = wdata.searchKey
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetSearchLibrary}?searchKey=${searchKey}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Validate Client Checking for exist or not
export const GetCompanyAddress = createAsyncThunk("appCommonReducers/GetCompanyAddress", async (agentId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCompanyAddress}?agentId=${agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Preview Document
export const GetPreviewDocument = createAsyncThunk("appCommonReducers/GetPreviewDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetPreviewDocument}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetSOCPreviewDocument = createAsyncThunk("appCommonReducers/GetSOCPreviewDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetPreviewDocument}?woId=${wdata.woId}&isSoc=${wdata.bool}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Preview Document
export const PreviewLLABDocument = createAsyncThunk("appCommonReducers/PreviewLLABDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.PreviewLLABDocument}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Classes List
export const GetClassesList = createAsyncThunk("appCommonReducers/GetClassesList", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetClassesList}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const classesList = []
    resultData.forEach((element) => {
      classesList.push({ value: `${element.className} - ${element.classFullName}`, label: `${element.className} - ${element.classFullName}`, classFullName: element.classFullName, className: element.className, leftValue: element.leftValue, rightValue: element.rightValue })
    })
    return {
      data: classesList,
      spinner: true,
      tokenExp: false
    }
  }
})

// start workorder omments
export const getWorkordersByIdComments = createAsyncThunk("appCommonReducers/getWorkordersByIdComments", async (woId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetWorkorderComments}?woId=${woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Authorization Document 
export const GetAuthorizationDocument = createAsyncThunk("appCommonReducers/GetAuthorizationDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAuthorizationDocument}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Create Workorder Comment
export const createWorkOrderComment = createAsyncThunk("appCommonReducers/createWorkOrderComment", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateComment}`
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false,
      needstatus: obj.status,
      needcomment: obj.comment
    }
  }
})
// end workorder omments


// Update Billing Prefix Workorder
export const UpdateBillingPrefix = createAsyncThunk("appCommonReducers/UpdateBillingPrefix", async (wdata) => {
  const method = 'patch'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateBillingPrefix}?woId=${wdata.woId}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={"Billing Prefix Updated Successfully"} status={"success"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update Resend Email Workorder
export const UpdateResendEmail = createAsyncThunk("appCommonReducers/UpdateResendEmail", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.UpdateResendEmail}?woId=${wdata.woId}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={"Resend Email Successfully"} status={"success"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update Billing Prefix Workorder
export const RegenerateAuthorizationLetter = createAsyncThunk("appCommonReducers/RegenerateAuthorizationLetter", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RegenerateAuthorizationLetter}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={"Document Regenerated Successfully"} status={"success"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const RegenerateLLABDocument = createAsyncThunk("appCommonReducers/RegenerateLLABDocument", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.RegenerateLLABDocument}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={"Document Regenerated Successfully"} status={"success"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})


// get byte array format
export const getInvoiceFileData = createAsyncThunk("appCommonReducers/getInvoiceFileData", async (fileId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetWorkOrderFilesByFileId}?fileId=${fileId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getWorkordersById = createAsyncThunk("appCommonReducers/getWorkordersById", async (woId) => {
  const authAxios = DefaultConfig().authAxios
  const resultData = await authAxios.get(`GetWorkOrderById/${woId}`)
    .then((response) => {
      const respData = response.data
      if (respData) {
        if (respData.success) {
          const resData = respData.data
          if (resData) {
            return {
              data: resData,
              spinner: true,
              tokenExp: false
            }
          }
        } else {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: true,
            tokenExp: false
          }
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 403) {
          toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: true
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          // const error = errorresponse.data.error
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: false
          }
        }
      }
    })
  return resultData
})

export const getNeedMoreInfoTracking = createAsyncThunk("appCommonReducers/getNeedMoreInfoTracking", async (woId) => {
  const authAxios = DefaultConfig().authAxios
  const resultData = await authAxios.get(`NeedMoreInfoTracking/${woId}/${false}`)
    .then((response) => {
      const respData = response.data
      if (respData) {
        if (respData.success) {
          const resData = respData.data
          if (resData) {
            return {
              data: resData,
              spinner: true,
              tokenExp: false
            }
          }
        } else {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: true,
            tokenExp: false
          }
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 403) {
          toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: true
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          // const error = errorresponse.data.error
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: false
          }
        }
      }
    })
  return resultData
})

export const downloadPDF = createAsyncThunk("appCommonReducers/downloadPDF", async (data) => {
  const authAxios = DefaultConfig().authAxios
  const obj = data.woIdData
  let apiname = ''
  if (data.name === 'NDA') {
    apiname = 'GeneratePMSCNDAAgreement'
  } else if (data.name === 'MSA') {
    apiname = 'GeneratePMSCMSAAgreement'
  } else if (data.name === 'PAS') {
    apiname = 'GeneratePMSCPAAgreement'
  } else if (data.name === 'SOC') {
    apiname = 'GenerateSOCAgreement'
  }
  const resultData = await authAxios.post(`${apiname}`, obj)
    .then((response) => {
      const respData = response.data
      if (respData) {
        if (respData.success) {
          const resData = respData.data
          if (resData) {
            return {
              data: resData,
              spinner: true,
              tokenExp: false
            }
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return {
              data: [],
              spinner: true,
              tokenExp: false
            }
          }
        } else {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: true,
            tokenExp: false
          }
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 403) {
          toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: true
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          // const error = errorresponse.data.error
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: false
          }
        }
      }
    })
  return resultData
})

export const getInvoiceData = createAsyncThunk("appCommonReducers/getInvoiceData", async (woId) => {
  const authAxios = DefaultConfig().authAxios
  const resultData = await authAxios.get(`GetinvoiceDetailsByWOId/${woId}`)
    .then((response) => {
      const respData = response.data
      if (respData) {
        if (respData.success) {
          const resData = respData.data
          if (resData) {
            return {
              data: resData,
              spinner: true,
              tokenExp: false
            }
          }
        } else {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: true,
            tokenExp: false
          }
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 403) {
          toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: true
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          // const error = errorresponse.data.error
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          return {
            data: [],
            spinner: false,
            tokenExp: false
          }
        }
      }
    })
  return resultData
})

// Start File Upload, download and remove files
export const getUpdateFileData = createAsyncThunk("appCommonReducers/getUpdateFileData", async (newObj) => {
  return newObj
})

export const getFailedFileData = createAsyncThunk("appCommonReducers/getFailedFileData", async (newObj) => {
  return newObj
})

export const closeProgressModal = createAsyncThunk("appCommonReducers/closeProgressModal", async (value) => {
  return value
})

// Get Vault Details
export const GetAllActiveVaultsForUser = createAsyncThunk("appCommonReducers/GetAllActiveVaultsForUser", async () => {
  const method = 'get'
  const endpoint = `User/${ApiUrls.GetAllActiveVaultsForUser}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Update Vault Details
export const UpdateCustomerVault = createAsyncThunk("appCommonReducers/UpdateCustomerVault", async (wdata) => {
  const method = 'post'
  const endpoint = `User/${ApiUrls.UpdateCustomerVault}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const uploadCompleted = createAsyncThunk("appCommonReducers/uploadCompleted", async ({ blocksData, values }, thunkAPI) => {
  try {
    const headers1 = {
      "X-File-Name": values['filename'],
      "X-WO-ID": values['woId'],
      "X-DocumentType": values.fileDto[0].documentType,
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    if (values.fileDto[0]?.fileIdExist) {
      headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
    }
    const authAxios = axios.create({
      baseURL: baseApiUrl,
      // headers: {
      //   "X-File-Name": values['filename'],
      //   "X-WO-ID": values['woId'],
      //   "X-DocumentType": values.fileDto[0].documentType,
      //   Authorization: `Bearer ${localStorage.getItem('token')}`
      // },
      headers: headers1,
      withCredentials: true
    })
    const response = await authAxios.post(`FileUpload/CompleteUpload`, blocksData)
    const resData = response.data
    if (resData.success) {
      const fileData = resData.data
      fileData['doumentType'] = values.fileDto[0].documentType
      const newObj = {}
      newObj['floader'] = true
      newObj['tokenExp'] = false
      newObj['fileData'] = fileData
      newObj['woType'] = values.fileDto[0].type
      newObj['woTypeId'] = values.woId
      newObj['stype'] = values.stype

      newObj['beginingOfTheChunk'] = 0
      newObj['endOfTheChunk'] = chunkSize
      newObj['blockData'] = []
      return newObj
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
  } catch (error) {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
  if (values.fileDto.length > 0) {
    const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
    try {
      let parseData = null
      if (values.fileDto[0]?.parse) {
        const headers1 = {
          "X-Total-Chunks": values['chunkCount'],
          "X-Chunk-Number": values['counter'],
          "X-File-Name": myEncodeURIComponent(values['filename']),
          "X-File-Size": values['fileSize'],
          "X-Chunk-Size": values['chunkSize'],
          "X-WO-ID": values['woId'],
          "X-DocumentType": values.fileDto[0].parse,
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        if (values.fileDto[0]?.fileIdExist) {
          headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
        }
        const authAxios = axios.create({
          baseURL: baseApiUrl,
          // headers: {
          //   "X-Total-Chunks": values['chunkCount'],
          //   "X-Chunk-Number": values['counter'],
          //   "X-File-Name": myEncodeURIComponent(values['filename']),

          //   "X-File-Size": values['fileSize'],
          //   "X-Chunk-Size": values['chunkSize'],
          //   "X-WO-ID": values['woId'],
          //   "X-DocumentType": values.fileDto[0]?.parse,
          //   "X-File-FileId": values.fileDto[0]?.fileIdExist,
          //   Authorization: `Bearer ${localStorage.getItem('token')}`
          // },
          headers: headers1,
          withCredentials: true
        })
        const responseParse = await authAxios.post(`FileUpload/ParseDocument`, chunk)
        if (responseParse?.data) {
          parseData = responseParse?.data?.data
        }
      }
      const headers1 = {
        "X-Total-Chunks": values['chunkCount'],
        "X-Chunk-Number": values['counter'],
        "X-File-Name": myEncodeURIComponent(values['filename']),
        "X-File-Size": values['fileSize'],
        "X-Chunk-Size": values['chunkSize'],
        "X-WO-ID": values['woId'],
        "X-DocumentType": values.fileDto[0].documentType,
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
      if (values.fileDto[0]?.fileIdExist) {
        headers1["X-File-FileId"] = values.fileDto[0].fileIdExist
      }
      const authAxios = axios.create({
        baseURL: baseApiUrl,
        // headers: {
        //   "X-Total-Chunks": values['chunkCount'],
        //   "X-Chunk-Number": values['counter'],
        //   "X-File-Name": myEncodeURIComponent(values['filename']),
        //   "X-File-Size": values['fileSize'],
        //   "X-Chunk-Size": values['chunkSize'],
        //   "X-WO-ID": values['woId'],
        //   "X-DocumentType": values.fileDto[0].documentType,
        //   "X-File-FileId": values.fileDto[0]?.fileIdExist,
        //   Authorization: `Bearer ${localStorage.getItem('token')}`
        // },
        headers: headers1,
        withCredentials: true
      })
      const response = await authAxios.post((`FileUpload/FileUploadChunks`), chunk)
      const respdata = response.data
      if (respdata.success) {
        if (values?.apiType) {
          const fileData = respdata.data
          fileData['doumentType'] = values.fileDto[0].documentType
          const newObj = {}
          newObj['floader'] = true
          newObj['tokenExp'] = false
          newObj['fileData'] = fileData
          newObj['woType'] = values.fileDto[0].type
          newObj['woTypeId'] = values.woId
          newObj['stype'] = values.stype

          newObj['beginingOfTheChunk'] = 0
          newObj['endOfTheChunk'] = values['chunkSize']
          newObj['blockData'] = []
          newObj['parseData'] = parseData
          return newObj
        } else if (values['counter'] === values['chunkCount']) {
          const blocksData = values.blockData
          blocksData.push(respdata.data.blockId)
          if (respdata.data?.blockId) {
            const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
            const uploadedData = respayload.payload
            uploadCompleted['parseData'] = parseData
            return uploadedData
          } else {
            const newObj = {}
            const fileData = respdata.data
            fileData['doumentType'] = values.fileDto[0].documentType
            newObj['floader'] = true
            newObj['tokenExp'] = false
            newObj['fileData'] = fileData
            newObj['woType'] = values.fileDto[0].type
            newObj['woTypeId'] = values.woId
            newObj['stype'] = values.stype

            newObj['beginingOfTheChunk'] = 0
            newObj['endOfTheChunk'] = values['chunkSize']
            newObj['blockData'] = []
            newObj['parseData'] = parseData
            return newObj
          }
        } else {
          const blocksData = values.blockData
          blocksData.push(respdata.data.blockId)
          const beginingOfTheChunk = values['endOfTheChunk']
          const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
          const newObj = {}
          newObj['beginingOfTheChunk'] = beginingOfTheChunk
          newObj['endOfTheChunk'] = endOfTheChunk
          newObj['blockData'] = blocksData
          return newObj
        }
      } else {
        // console.log("Error Occurred:", data.errorMessage)
        thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
        toast(t => (<ToastMessage t={t} message={respdata?.errorMessage ? respdata?.errorMessage : "Something Went Wrong..."} status={"danger"} />))
        thunkAPI.dispatch(getFailedFileData({ filename: myDecodeURIComponent(values['filename']), showFail: true }))
        return ''
      }
    } catch (error) {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      // console.log("error", error)
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      return ''
    }
  }
})

export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {
  if (values.fileDto.length > 0) {
    const _file = values.fileDto[0].file
    // console.log(_file.size, 1048576 * 1024)
    if (_file.size <= 1048576 * 1024) {
      const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      const fileSize = _file.size
      const filename = _file.name ? _file.name : values['filename']
      values['chunkSize'] = chunkSize
      values['_file'] = _file
      values['chunkCount'] = chunkCount
      values['fileSize'] = fileSize
      values['filename'] = myEncodeURIComponent(filename)

      values['beginingOfTheChunk'] = 0
      values['endOfTheChunk'] = chunkSize
      values['blockData'] = []

      for (let i = 0; i < chunkCount; i++) {
        values['counter'] = i + 1
        const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
        const fileUploadData = respayload.payload
        if ((i + 1) === chunkCount) {
          if (fileUploadData) {
            thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            thunkAPI.dispatch(getFailedFileData({ filename: myDecodeURIComponent(values['filename']), showFail: false }))
            return {
              data: fileUploadData.fileData,
              spinner: fileUploadData.floader,
              tokenExp: fileUploadData.tokenExp,
              woType: fileUploadData.woType,
              woTypeId: fileUploadData.woTypeId,
              stype: fileUploadData.stype,
              parseData: fileUploadData.parseData,
              type: values['type']
            }
          } else {
            thunkAPI.dispatch(getFailedFileData({ filename: myDecodeURIComponent(values['filename']), showFail: true }))
            break
          }
        } else {
          if (fileUploadData) {
            thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
            values['endOfTheChunk'] = fileUploadData.endOfTheChunk
            values['blockData'] = fileUploadData.blockData
          } else {
            break
          }
        }
      }
    } else {
      toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
    }
  }
})

export const downloadChunk = createAsyncThunk("appCommonReducers/downloadChunk", async (values, thunkAPI) => {
  try {
    const authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: {
        "Content-Range": `bytes ${values.offset}-${values.end}/${values.totalSize}`,
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      withCredentials: true
    })
    const response = await authAxios.get(`FileUpload/GetFileContentByFileId?fileId=${values['fileId']}`)
    const resData = response.data
    if (resData.success) {
      const respData = resData.data
      return respData
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
      if (resData?.errorMessage) {
        toast(t => (<ToastMessage t={t} message={resData?.errorMessage} status={"danger"} />))
      } else {
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      }
    }
  } catch (error) {
    console.log("error", error)
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

export const getWoFile = createAsyncThunk("appCommonReducers/getWoFile", async (fileId, thunkAPI) => {
  thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
  const authAxios = DefaultConfig().authAxios
  const resultData = await authAxios.get(`FileUpload/GetFilePropertiesByFileId?fileId=${fileId}`)
  // console.log(resultData)
  const resData = resultData.data
  if (resData) {
    if (resData.success) {
      const respData = resData.data
      if (respData) {
        const fileName = respData.fileName
        const contentType = respData.contentType
        const totalSize = Number(respData.contentLength)
        // const chunkSize = 1024 * 1024 * 1// 1MB chunk size
        const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
        const chunks = []
        let offset = 0
        let counter = 1
        // let count = 0
        // const concatenatedArray = new Uint8Array(totalSize)

        while (offset < totalSize) {
          const end = Math.min(offset + chunkSize, totalSize) - 1
          const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
          const chunk = respayload.payload

          // const binaryString = Buffer.from(chunk, 'base64').toString('binary')
          // const chunkUint8Array = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)))
          // concatenatedArray.set(chunkUint8Array, count * chunkSize)

          chunks.push(chunk)
          offset += chunkSize
          if (counter === chunkCount) {
            thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
          } else {
            thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
          }
          counter++
          // count++
        }

        // // Combine base64 chunks into a single base64 string
        // const combinedBase64 = chunks.join('')
        // // Convert base64 string to binary data
        // const binaryData = atob(combinedBase64)
        // // Create array buffer from binary data
        // const arrayBuffer = new ArrayBuffer(binaryData.length)
        // const uint8Array = new Uint8Array(arrayBuffer)
        // for (let i = 0; i < binaryData.length; i++) {
        //   uint8Array[i] = binaryData.charCodeAt(i)
        // }

        // // Convert the Uint8Array to a Blob
        // const concatenatedBlob = new Blob([uint8Array], { type: contentType })

        const blobChunks = []
        // Fetch each chunk and push it to the array
        for (const chunk of chunks) {
          const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
          const blob = await response.blob()
          blobChunks.push(blob)
        }

        // Convert the Uint8Array to a Blob
        const concatenatedBlob = new Blob(blobChunks, { type: contentType })
        // Generate download URL
        const downloadUrl = URL.createObjectURL(concatenatedBlob)
        // Initiate a download by creating an anchor element and programmatically clicking it
        const link = document.createElement('a')
        link.href = downloadUrl
        let fileNameValue = fileName
        if (fileNameValue.includes("IHM_SOC")) {
          if (sessionStorage.getItem('authSRR')) {
            fileNameValue = fileNameValue
          } else {
            fileNameValue = fileNameValue.replace("IHM_SOC", "IHM_IC")
          }
        }
        link.download = fileNameValue
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(downloadUrl)

        return {
          data: { fileName, contentType, fileContent: '' },
          tokenExp: false
        }
      }
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
      if (resData?.errorMessage) {
        toast(t => (<ToastMessage t={t} message={resData?.errorMessage} status={"danger"} />))
      } else {
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      }
    }
  }
  // return resultData
})

export const getOpenFile = createAsyncThunk("appCommonReducers/getOpenFile", async (fileId, thunkAPI) => {
  thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
  const authAxios = DefaultConfig().authAxios
  const resultData = await authAxios.get(`FileUpload/GetFilePropertiesByFileId?fileId=${fileId}`)
  // console.log(resultData)
  const resData = resultData.data
  if (resData) {
    if (resData.success) {
      const respData = resData.data
      if (respData) {
        const fileName = respData.fileName
        const contentType = respData.contentType
        const totalSize = Number(respData.contentLength)
        // const chunkSize = 1024 * 1024 * 1// 1MB chunk size
        const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
        const chunks = []
        let offset = 0
        let counter = 1
        // let count = 0
        // const concatenatedArray = new Uint8Array(totalSize)

        while (offset < totalSize) {
          const end = Math.min(offset + chunkSize, totalSize) - 1
          const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
          const chunk = respayload.payload

          // const binaryString = Buffer.from(chunk, 'base64').toString('binary')
          // const chunkUint8Array = new Uint8Array([...binaryString].map(char => char.charCodeAt(0)))
          // concatenatedArray.set(chunkUint8Array, count * chunkSize)

          chunks.push(chunk)
          offset += chunkSize
          if (counter === chunkCount) {
            thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
          } else {
            thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
          }
          counter++
          // count++
        }

        if (chunks.length === 1 && (fileName.includes('.pdf') || fileName.includes('.PDF'))) {
          // // Convert base64 string to a Blob
          // const byteCharacters = atob(chunks)
          // const byteNumbers = new Array(byteCharacters.length)
          // for (let i = 0; i < byteCharacters.length; i++) {
          //   byteNumbers[i] = byteCharacters.charCodeAt(i)
          // }
          // const byteArray = new Uint8Array(byteNumbers)
          // const blob = new Blob([byteArray], { type: 'application/pdf' })

          const blobChunks = []
          // Fetch each chunk and push it to the array
          for (const chunk of chunks) {
            const response = await fetch(`data:application/pdf;base64,${chunk}`)
            const blob = await response.blob()
            blobChunks.push(blob)
          }
          const blob = new Blob(blobChunks, { type: 'application/pdf' })

          // Create a Blob URL
          const blobUrl = URL.createObjectURL(blob)
          // Open a new tab with the Blob URL
          window.open(blobUrl, '_blank')
        } else {
          // // Combine base64 chunks into a single base64 string
          // const combinedBase64 = chunks.join('')
          // // Convert base64 string to binary data
          // const binaryData = atob(combinedBase64)
          // // Create array buffer from binary data
          // const arrayBuffer = new ArrayBuffer(binaryData.length)
          // const uint8Array = new Uint8Array(arrayBuffer)
          // for (let i = 0; i < binaryData.length; i++) {
          //   uint8Array[i] = binaryData.charCodeAt(i)
          // }

          // // Convert the Uint8Array to a Blob
          // const concatenatedBlob = new Blob([uint8Array], { type: contentType })

          const blobChunks = []
          // Fetch each chunk and push it to the array
          for (const chunk of chunks) {
            const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
            const blob = await response.blob()
            blobChunks.push(blob)
          }
          const concatenatedBlob = new Blob(blobChunks, { type: contentType })
          // Generate download URL
          const downloadUrl = URL.createObjectURL(concatenatedBlob)
          // Initiate a download by creating an anchor element and programmatically clicking it
          const link = document.createElement('a')
          link.href = downloadUrl
          let fileNameValue = fileName
          if (fileNameValue.includes("IHM_SOC")) {
            fileNameValue = fileNameValue.replace("IHM_SOC", "IHM_IC")
          }
          link.download = fileNameValue
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(downloadUrl)
        }

        return {
          data: { fileName, contentType, fileContent: '' },
          tokenExp: false
        }
      }
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
      if (resData?.errorMessage) {
        toast(t => (<ToastMessage t={t} message={resData?.errorMessage} status={"danger"} />))
      } else {
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
      }
    }
  }
  // return resultData
})

export const saveMultipleFileUploads = createAsyncThunk("appCommonReducers/saveMultipleFileUploads", async (values) => {
  if (values.fileDto.length > 0) {
    const formData = new FormData()
    formData.append("file", values.fileDto[0].file)
    const authAxios = DefaultConfig().authAxios
    const resultData = await authAxios
      .patch(`MultipleFileUpload?wo_id=${values.woId}`, formData).then((response) => {
        const respData = response.data
        if (respData) {
          const resData = respData.data
          if (resData) {
            return {
              data: resData,
              spinner: true,
              tokenExp: false
            }
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            toast(t => (<ToastMessage t={t} message={requestBlockMessage} status={"danger"} />))
            return {
              data: [],
              spinner: false,
              tokenExp: true
            }
          } else {
            const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={error} status={"danger"} />))
            return {
              data: [],
              spinner: false,
              tokenExp: false
            }
          }
        }
      })
    return resultData
  }
})

export const removeWoFile = createAsyncThunk("appCommonReducers/removeWoFile", async (values) => {
  const method = 'delete'
  const endpoint = `${ApiUrls.RemoveWorkorderDocument}?woId=${values.woId}&fileId=${values.fileId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})
// End File Upload, download and remove files

export const saveCSVRCWDocument = createAsyncThunk("appCommonReducers/saveCSVRCWDocument", async (wdata) => {
  const values = wdata.fileData
  if (values.fileDto.length > 0) {
    const formData = new FormData()
    formData.append("file", values.fileDto[0].file)
    const woType = values.fileDto[0].type
    const method = 'post'
    const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ValidateVesselDetails}?woId=${values.woId}`
    const data = formData
    const resultData = await apiCall(method, endpoint, data)
    if (resultData) {
      return {
        data: resultData,
        spinner: true,
        tokenExp: false,
        woType,
        woTypeId: values.woId,
        stype: values.stype,
        errorMsg: ''
      }
    }
  }
})

export const getVendorsSharePointList = createAsyncThunk("appCommonReducers/getVendorsSharePointList", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVendorsData}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getQbEntities = createAsyncThunk("appCommonReducers/getQbEntities", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVendorsData}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getVesselOwnersSharePointList = createAsyncThunk("appCommonReducers/getVesselOwnersSharePointList", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselOwnersData}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getBillableVesselsForPreviousQuarter = createAsyncThunk("appCommonReducers/getBillableVesselsForPreviousQuarter", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetBillableVoyAges}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getERBPCListByIMONumber = createAsyncThunk("appCommonReducers/getERBPCListByIMONumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetERBPCListByIMONumber}?imoNumber=${wdata.imoNumber}&companyId=${wdata.companyId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getProductsDataByIMONumber = createAsyncThunk("appCommonReducers/getProductsDataByIMONumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetProductsDataByIMONumber}?imoNumber=${wdata.imoNumber}&companyId=${wdata.companyId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getLFBVesselIMONumber = createAsyncThunk("appCommonReducers/getLFBVesselIMONumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselDetailsByIMONumber}?imoNumber=${wdata.imoNumber}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getUpdatedBillableVoyAges = createAsyncThunk("appCommonReducers/getUpdatedBillableVoyAges", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetUpdatedBillableVoyages}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// IHM SOC API's
export const getIMONumbers = createAsyncThunk("appCommonReducers/getIMONumbers", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVesselsByAccountId}?companyId=${wdata.companyId}&agentId=${wdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const imos = []
    resultData.forEach((element) => {
      imos.push({ value: element.imoNumber, label: `${element.imoNumber} - ${element.nameofShip}`, disabled: element.isWorkorderExists, officialNumber: element.officialNumber })
    })
    return {
      data: imos,
      spinner: true,
      tokenExp: false
    }
  }
})
export const callApi = createAsyncThunk("appCommonReducers/callApi", async (data) => {
  return data
})
export const getRlmVessels = createAsyncThunk("appCommonReducers/getRlmVessels", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVesselsByAccountId}?companyId=${wdata.companyId}&agentId=${wdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const imos = []
    resultData.forEach((element) => {
      imos.push({
        value: element.imoNumber,
        label: element.imoNumber,
        imoNumber: element.imoNumber,
        isSameCompany: element.isSameCompany,
        isWorkorderExists: element.isWorkorderExists,
        vesselName: element.nameofShip,
        registrationDate: element.registrationDate,
        officialNumber: element.officialNumber
      })
    })
    return {
      data: imos,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getRlmrVessels = createAsyncThunk("appCommonReducers/getRlmrVessels", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllVesselsByAgent}?companyId=${wdata.companyId}&agentId=${wdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const imos = []
    resultData.forEach((element) => {
      imos.push({
        value: element.imoNumber,
        label: element.imoNumber,
        imoNumber: element.imoNumber,
        isSameCompany: element.isSameCompany,
        isWorkorderExists: element.isWorkorderExists,
        vesselName: element.nameofShip,
        registrationDate: element.registrationDate,
        officialNumber: element.officialNumber
      })
    })
    return {
      data: imos,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getListFiles = createAsyncThunk("appCommonReducers/getListFiles", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetListFiles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const RLMData = {
      fileName: 'RLM 300',
      id: 1,
      documents: [
        {
          id: 1314,
          parentId: 2,
          linkFilename: "RLM300.pdf",
          fileDisplayName: "Electronic Version of Maritime Law, Regulations, Notices & Requirements (Combined Publications Folder)",
          fileLastUpdated: "March 17, 2025",
          modified: "",
          fileVersion: "2025"
        }
      ],
      children: [],
      fileDisplayName: 'RLM 300'
    }
    resultData.push(RLMData)
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})
export const GetImoListFiles = createAsyncThunk("appCommonReducers/GetImoListFiles", async (wdata) => {
  const method = 'post'
  const endpoint = `PUB/RLM/${ApiUrls.GetImoListFiles}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const SendFeedBackEmail = createAsyncThunk("appCommonReducers/SendFeedBackEmail", async (wdata) => {
  const method = 'post'
  const endpoint = `PUB/${ApiUrls.SendFeedBackEmail}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getVesselByofficialnumber = createAsyncThunk("appCommonReducers/getVesselByofficialnumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselByofficialnumber}?officialNumber=${wdata.officialNumber}&companyId=${wdata.companyId ? wdata.companyId : 0}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const companys = []
    const billingParties = resultData.billingParties
    if (billingParties) {
      billingParties.forEach((element) => {
        if (element?.isDefaultBillingParty) {
          companys.push({ value: element.id, label: `${element.name} - ${element.type} - ${element.isDefaultBillingParty ? '(Default)' : null}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode, isDefaultBillingParty: element.isDefaultBillingParty, billingCountryCode: element.billingCountryCode, billingStateCode: element.billingStateCode })
        } else {
          companys.push({ value: element.id, label: `${element.name} - ${element.type}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode, isDefaultBillingParty: element.isDefaultBillingParty, billingCountryCode: element.billingCountryCode, billingStateCode: element.billingStateCode })
        }

      })
    }
    return {
      data: resultData,
      companysData: companys,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVesselByIMO = createAsyncThunk("appCommonReducers/GetVesselByIMO", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselByIMO}?imoNumber=${wdata.imoNumber}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const companys = []
    const billingParties = resultData.billingParties
    if (billingParties) {
      billingParties.forEach((element) => {
        companys.push({ value: element.id, label: `${element.name} - ${element.type}`, name: `${element.name}- ${element.agentId}`, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode })
      })
    }
    return {
      data: resultData,
      companysDataName: companys,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVesselLABByIMONumber = createAsyncThunk("appCommonReducers/GetVesselLABByIMONumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselByIMO}?imoNumber=${wdata.imoNumber}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const companys = []
    const billingParties = resultData.billingParties
    if (billingParties) {
      billingParties.forEach((element) => {
        if (element?.isDefaultBillingParty) {
          companys.push({
            value: element.id, label: `${element.name} - ${element.type} - ${element.isDefaultBillingParty ? '(Default)' : null}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode, isDefaultBillingParty: element.isDefaultBillingParty, billingCountryCode: element.billingCountryCode, billingStateCode: element.billingStateCode
          })
        } else {
          companys.push({
            value: element.id, label: `${element.name} - ${element.type}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode, isDefaultBillingParty: element.isDefaultBillingParty, billingCountryCode: element.billingCountryCode, billingStateCode: element.billingStateCode
          })
        }
      })
    }
    return {
      data: resultData,
      companysDataName: companys,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getVesselByImoNumber = createAsyncThunk("appCommonReducers/getVesselByImoNumber", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetVesselByIMONumber}?imoNumber=${wdata.imoNumber}&companyId=${wdata.companyId ? wdata.companyId : 0}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const companys = []
    const billingParties = resultData.billingParties
    if (billingParties) {
      billingParties.forEach((element) => {
        companys.push({ value: element.id, label: `${element.name} - ${element.type}`, name: element.name, address: element.address, billingEmailTO: element.billingEmailTo, accountEmailTo: element.accountEmailTo, agentId: element.agentId, billingStreet: element.billingStreet, billingCity: element.billingCity, billingState: element.billingState, billingCountry: element.billingCountry, postalCode: element.postalCode, billingCountryCode: element.billingCountryCode })
      })
    }
    return {
      data: resultData,
      companysData: companys,
      spinner: true,
      tokenExp: false
    }
  }
})

export const ResendEmails = createAsyncThunk("appCommonReducers/ResendEmails", async (wdata) => {
  const method = 'post'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.ResendEmails}?woId=${wdata.woId}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCompanyAddressdetails = createAsyncThunk("appCommonReducers/GetCompanyAddressdetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCompanyAddressdetails}?agentId=${wdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetERBRAVersionChecking = createAsyncThunk("appCommonReducers/GetERBRAVersionChecking", async (payloadData) => {
  const method = 'get'
  const endpoint = `${payloadData.ccode}/${payloadData.tcode}/${ApiUrls.GetSoftwareVersionPClist}?companyId=${payloadData.companyId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getAllProductCodes = createAsyncThunk("appCommonReducers/getAllProductCodes", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetAllProducts}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const productCodes = []
    resultData.forEach((element) => {
      productCodes.push({ code: element.productCode, name: element.description, id: element.id })
    })
    return {
      data: productCodes,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CurrentQBbyCompany = createAsyncThunk("appCommonReducers/CurrentQBbyCompany", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetCurrentQBbyCompany}?companyId=${wdata.companyId}&woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

//Investigation API calls's

export const GetPortByName = createAsyncThunk("appCommonReducers/GetPortByName", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetPortByName}?portName=${wdata.name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const portCities = []
    resultData.forEach((element) => {
      portCities.push({ value: element.portId, label: element.portName })
    })
    return {
      data: portCities,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetInvestigatorByCityId = createAsyncThunk("appCommonReducers/GetInvestigatorByCityId", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInvestigatorByCityId}?cityId=${wdata.cityId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  console.log(resultData, 'resultData')
  if (resultData) {
    const InvestigatorCity = []
    resultData.forEach((element) => {
      InvestigatorCity.push({ value: element.investigatorId, label: element.investigatorName, investigatorEmail: element.investigatorEmail })
    })
    return {
      data: InvestigatorCity,
      spinner: true,
      tokenExp: false
    }
  }
})
export const GetInspectorDetailsByPortId = createAsyncThunk("appCommonReducers/GetInspectorDetailsByPortId", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInspectorDetailsByPortId}?portId=${wdata.name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // const InvestigatorCity = []
    // resultData.forEach((element) => {
    //   InvestigatorCity.push({ value: element.investigatorId, label: element.investigatorName, investigatorEmail: element.investigatorEmail })
    // })
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetInspectorByName = createAsyncThunk("appCommonReducers/GetInspectorByName", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetInspectorByName}?name=${wdata.name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // const InvestigatorCity = []
    // resultData.forEach((element) => {
    //   InvestigatorCity.push({
    //     value: element.investigatorId, label: `${element.investigatorFirstName}  ${element.investigatorLastName}`, investigatorEmail: element.investigatorEmail, agentID: element.agentID, cityID: element.cityID, companyName: element.companyName, investigatorLastName: element.investigatorLastName, investigatorFirstName: element.investigatorFirstName
    //   })
    // })
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetExpenseProducts = createAsyncThunk("appCommonReducers/GetExpenseProducts", async (wdata) => {
  const method = 'get'
  const endpoint = `${wdata.ccode}/${wdata.tcode}/${ApiUrls.GetExpenseProducts}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const allExpansesProducts = []
    resultData.forEach((element) => {
      allExpansesProducts.push({
        value: element.description, label: element.description, productCode: element.productCode, isDisabled: false
      })
    })
    return {
      data: allExpansesProducts,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetInActiveInvoice = createAsyncThunk("appCommonReducers/GetInActiveInvoice", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetInActiveInvoiceById}?woId=${wdata.woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const inActiveInvoices = []
    resultData.forEach((element) => {
      if (!element?.isActive) {
        inActiveInvoices.push({
          amount: element.amount, createdBy: element.createdBy, discount: element.discount, id: element.id, invoiceCreatedDate: element.invoiceCreatedDate, isActive: element.isActive, paymentMode: element.paymentMode, status: element.status, transactionId: element.transactionId, woId: element.woId, woTypeId: element.woTypeId, gpInvoiceCreatedDate: element.gpInvoiceCreatedDate, cashReceiptId: element.cashReceiptId
        })
      }
    })
    return {
      data: inActiveInvoices,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAccountByAgentId = createAsyncThunk("appCommonReducers/GetAccountByAgentId", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAccountByAgentId}?agentId=${wdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetQBFilterWorkorders = createAsyncThunk("appCommonReducers/GetQBFilterWorkorders", async (adata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.QBFilterWorkorders}`
  const data = adata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const recCount = resultData.vesselTotalCount
    const gridSize = 10 // resultData.pageSize
    return {
      data: resultData.vessel,
      totalCount: resultData.vesselTotalCount,
      spinner: true,
      tokenExp: false,
      recCount,
      gridSize
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetWorkorderProducts = createAsyncThunk("appCommonReducers/GetWorkorderProducts", async ({ catCode, typeCode, woId }) => {
  const method = 'get'
  // let WorkorderProductendpoint = ''
  // if (catCode === 'ERB' && (typeCode === 'CAS' || typeCode === 'SBI' || typeCode === 'QB')) {
  //   WorkorderProductendpoint = `${catCode}/${typeCode}/${ApiUrls.GetWorkorderProducts}?woId=${woId}`
  // } else if (catCode === 'IHM' && (typeCode === 'SOC')) {
  //   const agentNumber = agentId !== null ? agentId : null
  //   const invoiceId = invoiceNumber !== null ? invoiceNumber : 0
  //   WorkorderProductendpoint = `${catCode}/${typeCode}/${ApiUrls.GetWorkorderProducts}?agentId=${agentNumber}&invoiceId=${invoiceId}`
  // } else {
  // WorkorderProductendpoint = `${catCode}/${typeCode}/${ApiUrls.GetWorkorderProducts}`
  // }
  let endpoint = ''
  if (catCode === 'ERB' && (typeCode === 'CAS' || typeCode === 'SBI' || typeCode === 'QB')) {
    endpoint = `${catCode}/${typeCode}/${ApiUrls.GetWorkorderProducts}?woId=${woId}`
  } else {
    endpoint = `${catCode}/${typeCode}/${ApiUrls.GetWorkorderProducts}`
  }
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDiscountProductCodeAmount = createAsyncThunk("appCommonReducers/GetDiscountProductCodeAmount", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetDiscountProductCodeAmount}`
  const data = wdata

  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CancelAndReplaceWorkorderInvoice = createAsyncThunk("appCommonReducers/CancelAndReplaceWorkorderInvoice", async (wdata) => {
  const method = 'post'
  const creatingEndPoint = `${wdata.catCode}/${wdata.typeCode}/${ApiUrls.CancelAndReplaceWorkorderInvoice}`
  const endpoint = creatingEndPoint
  const data = wdata.submittedData[0]
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const setShowHideMenuData = createAsyncThunk("appCommonReducers/setShowHideMenuData", async (name) => {
  return name
})

export const getStepNameStatus = createAsyncThunk("appCommonReducers/getStepNameStatus", async (name) => {
  return name
})

export const getClearStatus = createAsyncThunk("appCommonReducers/getClearStatus", async () => {
  return ''
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
  return ''
})

export const getClearPaymentStatus = createAsyncThunk("appCommonReducers/getClearPaymentStatus", async () => {
  return ''
})

export const createWorkorder = createAsyncThunk("appCommonReducers/createWorkorder", async (boolean) => {
  return { boolean }
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
  return ''
})

export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
  return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
  return ''
})

export const insertNewCompanyData = createAsyncThunk("appCommonReducers/insertNewCompanyData", async (data) => {
  return { data }
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
  return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
  return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
  return ''
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    menuBoolean: false,
    empMenuData: [
      {
        id: "dashboard",
        title: "Dashboard",
        icon: '',
        img: themeConfig.navicons.kpi,
        img1: themeConfig.navicons.kpi1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/QB_Reports",
        show: false,
        children: [
          {
            id: "qbReports",
            title: "QB Reports",
            img: themeConfig.navicons.qb,
            img1: themeConfig.navicons.qb1,
            icon: '',
            show: true,
            color1: '#fff',
            color2: '#313131',
            navLink: "/QB_Reports"
          }
        ]
      },
      // {
      //   id: "dashboard",
      //   title: "Dashboard",
      //   icon: '',
      //   img: themeConfig.navicons.dashboard,
      //   img1: themeConfig.navicons.dashboard1,
      //   color1: '#fff',
      //   color2: '#313131',
      //   navLink: "/dashboard",
      //   show: true
      // },
      {
        id: "search",
        title: "Work Orders",
        icon: '',
        img: themeConfig.navicons.Search,
        img1: themeConfig.navicons.Search1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/search",
        show: false
      },
      {
        id: "appSettings",
        title: "Role Management",
        icon: '',
        img: themeConfig.navicons.appSettings,
        img1: themeConfig.navicons.appSettings1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/role-management",
        show: false
      },
      {
        id: "PUB",
        title: "Publications",
        icon: '',
        img: themeConfig.navicons.subscriptions,
        img1: themeConfig.navicons.subscriptions1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/Publications",
        show: false
      },
      // {
      //   id: "registry",
      //   title: "IMO Registry",
      //   icon: '',
      //   img: themeConfig.navicons.registry,
      //   img1: themeConfig.navicons.registry1,
      //   color1: '#fff',
      //   color2: '#313131',
      //   navLink: "/registry",
      //   show: true
      // },
      {
        id: "account",
        title: "Account",
        icon: '',
        img: themeConfig.navicons.Profile,
        img1: themeConfig.navicons.Profile1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/my-profile",
        show: true
      }
    ],
    cusMenuData: [
      // {
      //   id: "dashboard",
      //   title: "Dashboard",
      //   icon: '',
      //   img: themeConfig.navicons.dashboard,
      //   img1: themeConfig.navicons.dashboard1,
      //   color1: '#fff',
      //   color2: '#313131',
      //   navLink: "/dashboard",
      //   show: false
      // },
      {
        id: "search",
        title: "Work Orders",
        icon: '',
        img: themeConfig.navicons.Search,
        img1: themeConfig.navicons.Search1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/search",
        show: true
      },
      {
        id: "PUB",
        title: "Publications",
        icon: '',
        img: themeConfig.navicons.subscriptions,
        img1: themeConfig.navicons.subscriptions1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/Publications",
        show: false
      },
      // {
      //   id: "registry",
      //   title: "IMO Registry",
      //   icon: '',
      //   img: themeConfig.navicons.registry,
      //   img1: themeConfig.navicons.registry1,
      //   color1: '#fff',
      //   color2: '#313131',
      //   navLink: "/registry",
      //   show: false
      // },
      {
        id: "account",
        title: "Account",
        icon: '',
        img: themeConfig.navicons.Profile,
        img1: themeConfig.navicons.Profile1,
        color1: '#fff',
        color2: '#313131',
        navLink: "/my-profile",
        show: true
      }
    ],
    cancelSub: null,
    woCates: [],
    spinner1: false,
    enableAction: false,
    unauthorize: false,

    woStages: [],
    spinner2: false,

    woData: [],
    spinner3: false,
    recCount: 0,
    gridSize: 0,

    srRecCount: 0,
    srGridSize: 0,
    dashboardQbVessels: [],

    cloader: false,
    countryStates: [],

    dloader: false,
    documentTypes: [],

    woIData: null,
    spinner4: false,

    needMoreTracking: false,

    woIdComments: [],
    spinnerComment: false,
    needstatus: '',
    needcomment: '',

    wloader: false,
    woIdData: null,
    invoiceFileId: null,
    autherizationFileId: null,
    pdfData: null,

    woIdDocs: [],
    wdloader: false,

    fileData: {},
    parseData: null,
    uploadErrMsg: '',
    woType: '',
    stype: '',
    woTypeId: null,
    floader: true,

    filePreData: {},

    mfileData: {},
    mloader: true,
    mfileStatus: '',
    failedFileData: [],
    upCount: 0,

    msfileData: {},
    msloader: true,

    tokenExp: false,

    invoiceData: {},
    ispinner: false,

    woBool: false,

    allCompanies: [],
    allPrimaryCompanies: [],
    allPrimaryBillingAddress: [],
    acSpinner: false,
    acPrimarySpinner: false,
    checkwoData: null,

    invoicefileData: null,
    vesselImoData: null,

    RCWVendorSpinner: false,
    RCWVesOwnerSpinner: false,
    vendorSharepointList: [],
    vesselOwnersSharePointList: [],
    billableVesPreQuatSpin: false,
    billableVesPreQuat: [],
    billedVesselSpin: false,
    billedVesselData: [],

    imoloader: false,
    imoData: [],

    imovloader: false,
    imoVesselData: {},
    imoVesselData1: {},
    imoLABVesselData: {},
    invistigatorPort: [],
    InvestigatorCityData: [],
    allInvestigatorCityData: [],
    allExpansesProducts: [],
    inActiveInvoices: [],
    inActiveLoader: false,
    vesselByOfficialNumber: [],

    imocloader: false,
    imoCompanyData: [],
    imoCompanyDataName: [],
    imoLABCompanyDataName: [],

    total: 0,
    counter: 0,
    progress: false,
    fileCount: 0,
    totalfilecount: [],

    fileStatus: '',
    fileExceed: false,

    bwloader: false,
    bwData: null,

    agloader: false,
    agData: null,

    agloaderBwo: false,
    agDataBwo: null,

    itloader: false,
    itData: null,

    validateCData: null,
    Comdet: null,
    pvSpinner: false,
    pvData: null,
    pspinner: false,
    allproductCodes: [],
    allClassesListData: [],
    icaApiCall: {},
    unEditableFields: [],
    cancelAndReplace: null,
    agentAddress: {},
    usersData: null,
    uspiner: false,
    userRoleData: null,
    urspiner: false,
    erbCList: [],

    erbCListSpin: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getWorkOrderTypesAndCategories.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner1 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          const resData = action.payload.data
          const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).isEmployee
          const userData = JSON.parse(localStorage.getItem('userData'))
          let woIdTypeData = []
          let allAccess = false
          if (userData) {
            const userRoles = userData.userRoles
            if (userRoles) {
              const findRole = userRoles.find(find => find.rId === 1)
              if (findRole || !isEmployee) {
                state.enableAction = true
              }
              for (let i = 0; i < userRoles.length; i++) {
                const role = userRoles[i]
                if (role.rId === 1 || role.rId === 2 || role.rId === 3) {
                  woIdTypeData = []
                  allAccess = true
                  break
                } else {
                  const wtId = role.wtId
                  if (wtId) {
                    if (!woIdTypeData.includes(wtId)) {
                      woIdTypeData.push(wtId)
                    }
                  }
                }
              }
            }
          }

          const woCatgs = []
          if ((isEmployee) ? (woIdTypeData.length > 0 || allAccess) : true) {
            resData.forEach((element) => {
              const woTypesData = []
              if (element.workorderTypes) {
                element.workorderTypes.forEach((ele) => {
                  if (isEmployee ? (allAccess ? true : (woIdTypeData.includes(ele.typeId))) : true) {
                    if (((element.categoryCode === 'PUB' && ele.typeCode === 'RLMR') || (element.categoryCode === 'PMS' && ele.typeCode === 'CAS')) || (element.categoryCode === 'LFB' && ele.typeCode === 'PCAS') || (element.categoryCode === 'LFB' && ele.typeCode === 'SCAS') || (element.categoryCode === 'LFB' && ele.typeCode === 'PRC') || (element.categoryCode === 'LFB' && ele.typeCode === 'SRC') || (element.categoryCode === 'IHM' && (ele.typeCode === 'PCAS' || ele.typeCode === 'SCAS' || ele.typeCode === 'PRC' || ele.typeCode === 'SRC'))) {
                      woTypesData.push({ value: ele.typeId, label: ele.type, code: ele.typeCode, description: ele.description, disabled: true, isPublic: ele.isPublic })
                    } else {
                      woTypesData.push({ value: ele.typeId, label: ele.type, code: ele.typeCode, description: ele.description, disabled: false, isPublic: ele.isPublic })
                    }
                  }
                })
              }
              if (woTypesData.length > 0) {
                if (!isEmployee && element.categoryCode === 'INC') {
                  woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData, disabled: true })
                } else if (!isEmployee && element.categoryCode === 'LAB') {
                  // woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData, disabled: true })
                } else if ((!isEmployee || isEmployee) && element.categoryCode === 'PUB') {
                  // woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData, disabled: true })
                } else {
                  woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData })
                }
                // if (woTypesData.length > 0 && element.categoryCode !== 'INC') {
                //   woCatgs.push({ value: element.categoryId, label: element.category, code: element.categoryCode, description: element.description, woTypes: woTypesData })
                // }
              }
            })
          }

          if (woCatgs.length > 0) {
            state.woCates = woCatgs
          } else {
            state.woCates = []
          }
        }
      })
      .addCase(getWorkorderStages.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner2 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woStages = action.payload.data
        }
      })
      .addCase(getCompanyDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.acSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allCompanies = action.payload.data
        }
      })
      .addCase(getCMCompanyDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.acSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allCompanies = action.payload.data
          state.unauthorize = action.payload.unauthorize
        }
      })
      .addCase(getPrimaryCompanyDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.acPrimarySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allPrimaryCompanies = action.payload.data
          state.allPrimaryBillingAddress = action.payload.primaryData
        }
      })
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(getCountryStates.fulfilled, (state, action) => {
        if (action.payload) {
          state.cloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.countryStates = action.payload.data
        }
      })
      .addCase(getWorkorders.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(getWorkordersByFilters.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(getVesselDashboard.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
          state.cancelSub = null
        }
      })
      .addCase(ValidateWorkorderCreation.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.checkwoData = action.payload.data
        }
      })
      .addCase(GetValidateClient.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.validateCData = action.payload.data
        }
      })
      .addCase(getBaseWorkorderData.fulfilled, (state, action) => {
        if (action.payload) {
          state.bwloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.bwData = action.payload.data
        }
      })
      .addCase(getDocumentTemplateData.fulfilled, (state, action) => {
        if (action.payload) {
          if (action.payload.reqData) {
            if (action.payload.reqData.docType === 'Agr') {
              state.agloader = action.payload.spinner
              state.agData = action.payload.data
            } else if (action.payload.reqData.docType === 'AgrBwo') {
              state.agloaderBwo = action.payload.spinner
              state.agDataBwo = action.payload.data
            } else {
              state.itloader = action.payload.spinner
              state.itData = action.payload.data
            }
          }
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(CreateWorkorder.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(getWorkordersData.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      .addCase(updateWoExpenses.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.stype = ''
        }
      })
      .addCase(updateWoData.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.stype = ''
        }
      })
      .addCase(UpdateWorkorder.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(UpdateIsNeedMoreInfo.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(UpdateNeedMoreInfoStatus.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(CancelWorkorder.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
          if (action.payload.data) {
            const payloadData = { ...action.payload.data }
            if (payloadData) {
              state.invoiceFileId = payloadData.invoiceFileId
              state.autherizationFileId = payloadData.autherizationFileId
            } else {
              state.invoiceFileId = null
              state.autherizationFileId = null
            }
          } else {
            state.invoiceFileId = null
            state.autherizationFileId = null
          }
          state.uploadErrMsg = ''
        }
      })
      .addCase(getWorkordersById.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner4 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIData = action.payload.data
        }
      })
      .addCase(getNeedMoreInfoTracking.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.needMoreTracking = action.payload.data
        }
      })
      .addCase(downloadPDF.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.pdfData = action.payload.data
        }
      })
      .addCase(getInvoiceData.fulfilled, (state, action) => {
        if (action.payload) {
          state.ispinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.invoiceData = action.payload.data
        }
      })
      .addCase(getInvoiceFileData.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.invoicefileData = action.payload.data
        }
      })
      .addCase(getWorkordersByIdComments.fulfilled, (state, action) => {
        state.spinnerComment = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.woIdComments = action.payload.data
      })
      .addCase(createWorkOrderComment.fulfilled, (state, action) => {
        const woIdComments = state.woIdComments
        woIdComments.push(action.payload.data)
        state.spinnerComment = action.payload.spinner
        state.tokenExp = action.payload.tokenExp
        state.woIdComments = woIdComments
        state.needstatus = action.payload.needstatus
        state.needcomment = action.payload.needcomment
      })
      .addCase(saveFileUploads.fulfilled, (state, action) => {
        if (action.payload) {
          state.upCount = state.upCount + 1
          if (state.upCount === state.totalfilecount?.length) {
            state.progress = true
          }
          if (!action.payload.type) {
            state.floader = action.payload.spinner
            state.tokenExp = action.payload.tokenExp
            state.fileData = action.payload.data
            state.woType = action.payload.woType
            state.woTypeId = action.payload.woTypeId
            state.stype = action.payload.stype
            state.parseData = action.payload.parseData
          } else if (action.payload.type === 'multisave') {
            state.msloader = action.payload.spinner
            state.tokenExp = action.payload.tokenExp
            state.msfileData = action.payload.data
          } else {
            state.mloader = action.payload.spinner
            state.tokenExp = action.payload.tokenExp
            state.mfileData = action.payload.data
          }
        } else {
          state.upCount = state.upCount + 1
          if (state.upCount === state.totalfilecount?.length) {
            state.progress = true
          }
          state.mfileStatus = 'not count match'
          if (action.payload) {
            if (!action.payload.type) {
              state.floader = true
            } else if (action.payload.type === 'multisave') {
              state.msloader = true
            } else {
              state.mloader = true
            }
          } else {
            state.fileExceed = true
          }
        }
      })
      .addCase(getFailedFileData.fulfilled, (state, action) => {
        if (action.payload) {
          let failedFileData = [...state.failedFileData]
          failedFileData.push({ filename: action.payload.filename, showFail: action.payload.showFail })
          failedFileData = failedFileData.filter((item, index, self) => index === self.findIndex(obj => obj.filename === item.filename && obj.showFail === item.showFail))
          state.failedFileData = failedFileData
        }
      })
      .addCase(closeProgressModal.fulfilled, (state, action) => {
        if (action.payload) {
          state.failedFileData = []
          state.progress = false
          state.upCount = 0
        }
      })
      .addCase(getUpdateFileData.fulfilled, (state, action) => {
        if (action.payload) {
          state.total = action.payload.total
          state.counter = action.payload.counter
          state.progress = action.payload.progress
          state.fileCount = action.payload.fileCount
          state.totalfilecount = action.payload.totalfilecount
          state.fileStatus = action.payload.fileStatus
        }
      })
      .addCase(removeWoFile.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(UpdateSubscription.fulfilled, (state, action) => {
        if (action.payload) {
          state.cancelSub = action.payload.cancelSub
        }
      })
      .addCase(getWoFile.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.filePreData = action.payload.data
        }
      })
      .addCase(getOpenFile.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.filePreData = action.payload.data
        }
      })
      .addCase(saveMultipleFileUploads.fulfilled, (state, action) => {
        if (action.payload) {
          state.mloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.mfileData = action.payload.data
        } else {
          state.mloader = true
        }
      })
      .addCase(saveCSVRCWDocument.fulfilled, (state, action) => {
        if (action.payload) {
          state.floader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.fileData = action.payload.data
          state.woType = action.payload.woType
          state.woTypeId = action.payload.woTypeId
          state.stype = action.payload.stype
          state.uploadErrMsg = action.payload.errorMsg
        } else {
          state.floader = true
        }
      })
      .addCase(setShowHideMenuData.fulfilled, (state, action) => {
        const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).isEmployee
        const name = action.payload
        const empMenuData = state.empMenuData
        const cusMenuData = state.cusMenuData
        if (isEmployee) {
          if (name) {
            const findIndex = empMenuData.findIndex(find => find.title === "Publications")
            if (findIndex >= 0) {
              // true
              empMenuData[findIndex].show = false
            }

            // const findIndexs = empMenuData.findIndex(find => find.title === "IMO Registry")
            // if (findIndexs >= 0) {
            //   empMenuData[findIndexs].show = true
            // }
          } else {
            const findIndex = empMenuData.findIndex(find => find.title === "Publications")
            if (findIndex >= 0) {
              // true
              empMenuData[findIndex].show = false
            }

            // const findIndexs = empMenuData.findIndex(find => find.title === "IMO Registry")
            // if (findIndexs >= 0) {
            //   empMenuData[findIndexs].show = true
            // }
          }
          state.empMenuData = empMenuData
          state.menuBoolean = !state.menuBoolean
        } else {
          if (name) {
            const findIndex = cusMenuData.findIndex(find => find.title === "Publications")
            if (findIndex >= 0) {
              // true
              cusMenuData[findIndex].show = false
            }

            // const findIndexs = cusMenuData.findIndex(find => find.title === "IMO Registry")
            // if (findIndexs >= 0) {
            //   cusMenuData[findIndexs].show = true
            // }
          } else {
            const findIndex = cusMenuData.findIndex(find => find.title === "Publications")
            if (findIndex >= 0) {
              cusMenuData[findIndex].show = false
            }

            // const findIndexs = cusMenuData.findIndex(find => find.title === "IMO Registry")
            // if (findIndexs >= 0) {
            //   cusMenuData[findIndexs].show = false
            // }
          }
          state.cusMenuData = cusMenuData
          state.menuBoolean = !state.menuBoolean
        }
      })
      .addCase(getStepNameStatus.fulfilled, (state) => {
        state.wdloader = false
        state.dloader = false
        // state.wloader = false
        state.cloader = false
        state.ispinner = false
      })
      .addCase(createWorkorder.fulfilled, (state, action) => {
        state.woBool = action.payload.boolean
      })
      .addCase(getClearMultiStatus.fulfilled, (state) => {
        state.mfileData = {}
        state.msfileData = {}
        state.mfileStatus = ''
      })
      .addCase(getClearStatus.fulfilled, (state) => {
        state.wdloader = false
        state.dloader = false
        state.wloader = false
        state.cloader = false
        state.ispinner = false
        state.woIData = null
        state.spinner3 = false
        state.bwloader = false
        state.bwData = null
        state.agloader = false
        state.agData = null
        state.agloaderBwo = false
        state.agDataBwo = null
        state.itloader = false
        state.itData = null
        state.imoData = []
        state.imoloader = false
        state.invoicefileData = null
      })
      .addCase(getClearPaymentStatus.fulfilled, (state) => {
        state.billedVesselSpin = false
        state.wloader = false
        state.ispinner = false
        state.spinner4 = false
        state.woIData = null
        state.woIdData = []
      })
      .addCase(getWoLoading.fulfilled, (state) => {
        state.spinner3 = false
      })
      .addCase(getClearStore.fulfilled, (state) => {
        state.woIdData = []
        state.woIData = null
        state.checkwoData = null
      })
      .addCase(getClearStoreData.fulfilled, (state) => {
        state.checkwoData = null
      })
      .addCase(insertNewCompanyData.fulfilled, (state, action) => {
        state.allCompanies = action.payload.data
      })
      .addCase(getClearFileData.fulfilled, (state) => {
        state.fileData = {}
        state.floader = true
      })
      .addCase(removeneedinfodata.fulfilled, (state) => {
        state.needcomment = ''
        state.needstatus = ''
      })
      .addCase(getFileExceed.fulfilled, (state) => {
        state.fileExceed = false
      })
      .addCase(getVendorsSharePointList.fulfilled, (state, action) => {
        if (action.payload) {
          state.billableVesPreQuatSpin = false
          state.billedVesselSpin = false

          state.billableVesPreQuat = []
          state.billedVesselData = []

          state.RCWVendorSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.vendorSharepointList = action.payload.data
        }
      })
      .addCase(getQbEntities.fulfilled, (state, action) => {
        if (action.payload) {
          state.unEditableFields = action.payload.data
        }
      })
      .addCase(getVesselOwnersSharePointList.fulfilled, (state, action) => {
        if (action.payload) {
          state.billableVesPreQuatSpin = false
          state.billedVesselSpin = false

          state.billableVesPreQuat = []
          state.billedVesselData = []

          state.RCWVesOwnerSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.vesselOwnersSharePointList = action.payload.data
        }
      })
      .addCase(getBillableVesselsForPreviousQuarter.fulfilled, (state, action) => {
        if (action.payload) {
          state.RCWVendorSpinner = false
          state.RCWVesOwnerSpinner = false
          state.billedVesselSpin = false

          state.vendorSharepointList = []
          state.vesselOwnersSharePointList = []
          state.billedVesselData = []

          state.billableVesPreQuatSpin = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.billableVesPreQuat = action.payload.data
        }
      })
      .addCase(getERBPCListByIMONumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.erbCListSpin = false
          state.erbCListSpin = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.erbCList = action.payload.data
        }
      })
      .addCase(getProductsDataByIMONumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.erbPListSpin = false
          state.erbPListSpin = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.erbPList = action.payload.data
        }
      })
      .addCase(getLFBVesselIMONumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.lfbCListSpin = false
          state.lfbCListSpin = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.lfbCList = action.payload.data
        }
      })
      .addCase(getUpdatedBillableVoyAges.fulfilled, (state, action) => {
        if (action.payload) {
          state.RCWVendorSpinner = false
          state.billableVesPreQuatSpin = false
          state.billableVesPreQuatSpin = false

          state.vendorSharepointList = []
          state.vesselOwnersSharePointList = []
          state.billableVesPreQuat = []

          state.billedVesselSpin = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.billedVesselData = action.payload.data
        }
      })
      .addCase(getIMONumbers.fulfilled, (state, action) => {
        if (action.payload) {
          state.imoloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.imoData = action.payload.data
        }
      })
      .addCase(callApi.fulfilled, (state, action) => {
        state.icaApiCall = action.payload
      })
      .addCase(GetVesselSyncData.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.vesselByOfficialNumber = action.payload.data
        }
      })
      .addCase(getVesselByImoNumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.imoVesselData = action.payload.data
          state.imoCompanyData = action.payload.companysData
        }
      })
      .addCase(GetPortByName.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.invistigatorPort = action.payload.data
        }
      })
      .addCase(GetInvestigatorByCityId.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.InvestigatorCityData = action.payload.data
        }
      })
      .addCase(GetInspectorByName.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allInvestigatorCityData = action.payload.data
        }
      })
      .addCase(GetExpenseProducts.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allExpansesProducts = action.payload.data
        }
      })
      .addCase(GetInActiveInvoice.fulfilled, (state, action) => {
        if (action.payload) {
          state.inActiveLoader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.inActiveInvoices = action.payload.data
        }
      })
      .addCase(GetQBFilterWorkorders.fulfilled, (state, action) => {
        if (action.payload) {
          // state.qbVesselsloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.dashboardQbVessels = action.payload.data
          state.srRecCount = action.payload.recCount
          // state.srGridSize = action.payload.gridSize
        }
      })
      .addCase(GetVesselByIMO.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.imoVesselData1 = action.payload.data
          state.imoCompanyDataName = action.payload.companysDataName
        }
      })
      .addCase(GetVesselLABByIMONumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.imoLABVesselData = action.payload.data
          state.imoLABCompanyDataName = action.payload.companysDataName
        }
      })
      .addCase(getVesselByofficialnumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.imoVesselData = action.payload.data
          state.imoCompanyData = action.payload.companysData
        }
      })
      .addCase(GetCompanyAddressdetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.Comdet = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetERBRAVersionChecking.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.pvSpinner = action.payload.spinner
          state.pvData = action.payload.data
        }
      })
      .addCase(getAllProductCodes.fulfilled, (state, action) => {
        if (action.payload) {
          state.pspinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allproductCodes = action.payload.data
        }
      })
      .addCase(GetClassesList.fulfilled, (state, action) => {
        if (action.payload) {
          state.imovloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allClassesListData = action.payload.data
        }
      })
      .addCase(CancelAndReplaceWorkorderInvoice.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.woIData = action.payload.data1
        }
      })
      .addCase(GetAccountByAgentId.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.agentAddress = action.payload
        }
      })
  }
})
export default commonreducerSlice.reducer
